import { render, staticRenderFns } from "./FormDonorInformationQuestion.vue?vue&type=template&id=7bcf67a2"
import script from "./FormDonorInformationQuestion.vue?vue&type=script&lang=js"
export * from "./FormDonorInformationQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports